/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/


import {FETCH_APPLICATION_DETAILS_AGE_RATING_REQUEST, FETCH_APPLICATION_DETAILS_AGE_RATING_SUCCESS, FETCH_APPLICATION_DETAILS_AGE_RATING_FAILURE} from './ApplicationDetailsAgeRatingTypes';

const initialState = {
  loading: false,
  applicationDetailsAgeRatings: [],
  error: "",
};

const applicationDetailsAgeRatingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_APPLICATION_DETAILS_AGE_RATING_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case FETCH_APPLICATION_DETAILS_AGE_RATING_SUCCESS:
      return {
        loading: false,
        applicationDetailsAgeRatings: action.payload,
        error: "",
      };
    case FETCH_APPLICATION_DETAILS_AGE_RATING_FAILURE:
      return {
        loading: false,
        applicationDetailsAgeRatings: state.applicationDetailsAgeRatings,
        error: action.payload,
      }
    default:
      return state;
  }
};

export default applicationDetailsAgeRatingReducer;
